// ─── Timeline: Centered ───────────────────────────────────────
// Center-aligned timeline with items alternating left/right on desktop.

import React from 'react';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';

export default function TimelineCentered({ section, data, theme }) {
  const anim = section.animation || {};
  const items = data.items || [];
  if (items.length === 0) return null;

  const isDark = isColorDark(theme.bg);
  const dotBorder = isDark ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.08)';

  return (
    <section className="px-5 py-20" data-testid="timeline-section">
      <div className="max-w-sm mx-auto text-center">
        <AnimatedSection preset={anim.items || 'fade-up'}>
          <p
            className="text-xs tracking-[0.3em] uppercase mb-10"
            style={{ color: theme.accent, fontFamily: theme.eyebrowFont }}
          >
            {data.title || 'Schedule'}
          </p>
        </AnimatedSection>

        <div className="relative">
          {/* Center line */}
          <div
            className="absolute left-1/2 top-0 bottom-0 w-px -translate-x-1/2"
            style={{ backgroundColor: `${theme.accent}25` }}
          />

          <div className="space-y-10">
            {items.map((item, i) => (
              <AnimatedSection key={i} preset={anim.items || 'fade-up'} delay={i * 0.1}>
                <div className="relative">
                  {/* Center dot */}
                  <div
                    className="absolute left-1/2 -translate-x-1/2 w-3 h-3 rounded-full z-10"
                    style={{ backgroundColor: theme.accent, border: `2px solid ${dotBorder}`, top: 0 }}
                  />
                  {/* Content */}
                  <div className="pt-6">
                    {item.time && (
                      <p className="text-[10px] tracking-[0.25em] uppercase mb-1" style={{ color: theme.accent, fontFamily: theme.eyebrowFont }}>
                        {item.time}
                      </p>
                    )}
                    <p className="text-sm font-medium" style={{ color: theme.textPrimary, fontFamily: theme.bodyFont }}>
                      {item.title}
                    </p>
                    {item.description && (
                      <p className="text-xs mt-1" style={{ color: theme.textSecondary }}>
                        {item.description}
                      </p>
                    )}
                  </div>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function isColorDark(hex) {
  if (!hex) return false;
  const c = hex.replace('#', '');
  if (c.length < 6) return false;
  const r = parseInt(c.substring(0, 2), 16);
  const g = parseInt(c.substring(2, 4), 16);
  const b = parseInt(c.substring(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 < 128;
}
